// extracted by mini-css-extract-plugin
export default {"List":"DocumentList_List__lokoj","InnerWrapper":"DocumentList_InnerWrapper__-87kd","Document":"DocumentList_Document__jLn8w","Divider":"DocumentList_Divider__bjqUu"};